export const projects = [
    {
      id: 1,
      image: 'https://raw.githubusercontent.com/AppsDevsLeon/gif/refs/heads/main/ChatGPT%20Image%2014%20may%202025%2C%2004_25_35.png',
      title: 'Tokeniza sin Código',
      description: 'Crear y lanzar tu propio token ERC20 como proyecto de tokenización, sin necesidad de programar.',
      link: '/course/token-project-viewer/1',
    },
   
  ];
  